import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { timeUntil } from '../browseFormat';
import { browseCreditMessages as messages } from '../browseMessages';

/** "7 h 12 min" until the credits reset; it updates each minute. */
export function useResetCountdown(resetsAt: string | undefined): string | null {
  const intl = useIntl();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 60 * 1000);
    return () => window.clearInterval(timer);
  }, []);

  if (resetsAt === undefined) {
    return null;
  }
  const { hours, minutes } = timeUntil(resetsAt, now);
  return hours > 0
    ? intl.formatMessage(messages.hoursMinutes, { hours, minutes })
    : intl.formatMessage(messages.minutesOnly, { minutes });
}
